import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CoreTracking } from "../../../../models/CoreTracking";
import ModalComponent from '../../../misc/ModalComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InactivateAsmUserTracking } from "../../../../store/TrackingOperationAction";
import { EmptyRequestState } from "../../../../models/RequestState";
import StatusCode from "../../../../util/StatusCode";
import Loading from "../../../misc/Loading";
import CoreApiError from "../../../misc/CoreApiError";
import { useTranslation } from "react-i18next";
import { RootState } from "../../../../store/store";



interface InactivateAsmUserTrackingWizardProps {
    tracking: CoreTracking
    close: (success: boolean) => void
}

const InactivateAsmUserTrackingWizard: React.FC<InactivateAsmUserTrackingWizardProps> = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation(["common", "schoolAdministration"]);
    const [wizardStep, setWizardStep] = useState<'confirm' | 'done'>('confirm');
    const inactivateAsmUserTracking = useSelector<RootState, EmptyRequestState>(state => state.trackingOperation.inactivateAsmUserTracking)

    const confirmInput: React.MouseEventHandler<HTMLButtonElement> = (_) => {
        InactivateAsmUserTracking(props.tracking.trackingId)(dispatch);
        setWizardStep('done');
    }

    const close = (success: boolean) => {
        setWizardStep('confirm');
        props.close(success);
    }

    switch (wizardStep) {
        case 'confirm': {
            return <ModalComponent
                isOpen={true}
                toggleModal={() => close(false)}
                header={t('trackingOperations.asm.inactivate.title', { ns: 'schoolAdministration' })}
                update={confirmInput}
                confirm={t('action.confirm', { ns: 'common' })}
                cancel={t('action.cancel', { ns: 'common' })}>
                <p><FontAwesomeIcon title="WARNING" color="#fc1" icon={['fas', 'triangle-exclamation']} /> {t('trackingOperations.asm.inactivate.warningMessage', { ns: 'schoolAdministration', sourceSystemId: props.tracking.sourceSystemId })}</p>
            </ModalComponent>
        }
        case 'done': {
            if (inactivateAsmUserTracking.code === StatusCode.COMPLETE) {
                return <ModalComponent
                    isOpen={true}
                    toggleModal={() => close(true)}
                    header={t('trackingOperations.asm.inactivate.title', { ns: 'schoolAdministration' })}
                    cancel={t('action.close', { ns: 'common' })}>{t('trackingOperations.asm.inactivate.complete', { ns: 'schoolAdministration' })}</ModalComponent>
            } else if (inactivateAsmUserTracking.code === StatusCode.ERROR) {
                return <ModalComponent
                    isOpen={true}
                    toggleModal={() => close(false)}
                    header={t('trackingOperations.asm.inactivate.title', { ns: 'schoolAdministration' })}
                    cancel={t('action.cancel', { ns: 'common' })}><CoreApiError  requestState={inactivateAsmUserTracking} /></ModalComponent>
            } else {
                return <ModalComponent
                    isOpen={true}
                    toggleModal={() => close(false)}
                    header={t('trackingOperations.asm.inactivate.title', { ns: 'schoolAdministration' })}
                    cancel={t('action.cancel', { ns: 'common' })}>
                    <Loading />
                </ModalComponent>;
            }
        }
    }
}

export default InactivateAsmUserTrackingWizard;
